import { useMemo } from "react";
import { useProductAvailability } from "hooks/useProductAvailability";
import { orderFormats } from "../components/Bundle/bundle.utils";
import { useBundleFormats } from "./useBundleFormats";
import type { FormatMeta } from "./mapSalesResponse";

interface UseBundleFormatMetaArgs {
  isBundled: boolean;
  workId?: string | null;
  bundleIsbns: string[];
  currentIsbn?: string;
}

export const useBundleFormatMeta = ({
  isBundled,
  workId,
  bundleIsbns,
  currentIsbn,
}: UseBundleFormatMetaArgs): {
  formats: FormatMeta[] | undefined;
  isFormatsLoading: boolean;
} => {
  const { isProductActive } = useProductAvailability();
  const { formats: workFormats, isLoading: isFormatsLoading } =
    useBundleFormats(isBundled ? workId : null);

  const formats = useMemo<FormatMeta[] | undefined>(() => {
    if (!isBundled || !currentIsbn) {
      return undefined;
    }
    const selected = new Set(bundleIsbns);
    return orderFormats(workFormats, currentIsbn, isProductActive)
      .filter((format) => selected.has(format.identifier))
      .map((format) => ({
        isbn: format.identifier,
        label: format.productGroupDescription || format.identifier,
      }));
  }, [bundleIsbns, currentIsbn, isBundled, isProductActive, workFormats]);

  return { formats, isFormatsLoading };
};
